import * as React from "react";
import { Outlet, useLocation, useNavigate, useNavigation } from "react-router-dom";

import { Box, CssBaseline, CssVarsProvider, GlobalStyles, LinearProgress } from "@mui/joy";

import { useLoggedIn } from "../security/Security";

import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import customTheme from "./components/theme";

export const MainLayout = (props) => {
    const location = useLocation();
    const navigate = useNavigate();

    const { user } = useLoggedIn();

    return (
        <CssVarsProvider disableTransitionOnChange theme={customTheme}>
            <GlobalStyles styles={globalStyles}/>
            <CssBaseline/>
            <LoadingBar/>
            <Box sx={{ display: "flex", minHeight: "100dvh" }}>
                <Header/>
                <Sidebar path={location.pathname} navigate={navigate} user={user}/>
                <Box className="MainContent" component="main" sx={sxContentBox}>
                    <Outlet/>
                </Box>
            </Box>
        </CssVarsProvider>
    );
};

const LoadingBar = () => {
    const loading = useNavigation().state === "loading";
    return loading ? <LinearProgress size="sm" thickness={1} variant="plain"/> : null;
};

export default MainLayout;

// private

const globalStyles = {
    "[data-feather], .feather": {
        color: "var(--Icon-color)",
        margin: "var(--Icon-margin)",
        fontSize: "var(--Icon-fontSize, 20px)",
        width: "1em",
        height: "1em"
    }
};

const sxContentBox = (theme) => {
    return {
        px: {
            xs: 2, md: 6
        }, pt: {
            xs: `calc(${theme.spacing(2)} + var(--Header-height))`,
            sm: `calc(${theme.spacing(2)} + var(--Header-height))`,
            md: 3
        }, pb: {
            xs: 2, sm: 2, md: 3
        }, flex: 1, display: "flex", flexDirection: "column", minWidth: 0, height: "100dvh", gap: 1
    };
};